import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol viewBox=\"0 0 18 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-download\">\n<path d=\"M1.4375 15.324H16.5625C16.7633 15.324 16.928 15.3884 17.0568 15.5172C17.1856 15.646 17.25 15.8108 17.25 16.0115C17.25 16.2123 17.1856 16.377 17.0568 16.5058C16.928 16.6346 16.7633 16.699 16.5625 16.699H1.4375C1.23675 16.699 1.07198 16.6346 0.943188 16.5058C0.814396 16.377 0.75 16.2123 0.75 16.0115C0.75 15.8108 0.814396 15.646 0.943188 15.5172C1.07198 15.3884 1.23675 15.324 1.4375 15.324ZM9.6875 9.86733L14.7578 4.79702L15.7464 5.76364L8.93606 12.574L2.12569 5.76364L3.09231 4.79702L8.31319 10.0179V0.199707H9.68819V9.86802L9.6875 9.86733Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/download.svg
// module id = R6Cl
// module chunks = 258